import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import ApiService from './../../network/ApiService';

const UpdateTeamForm = ({ teamID }) => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const apiService = useMemo(() => new ApiService(), []);

    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
        defaultValues: {
            email: '',
        }
    });

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const response = await apiService.get(`app/account`);
                if (response) {
                    setEmail(response.email || '');
                    setValue('email', response.email || '');
                }
            } catch (error) {
                toast.error('Failed to fetch team data.');
            }
        };
        fetchTeam();
    }, [teamID, apiService, setValue]);

    const onSubmit = async (data) => {
        try {
            const newEmail = data.email;

            if (newEmail !== email) {
                await apiService.patch(`app/account/email`, { email: newEmail });
                navigate('/kader');
            } else {
                toast.info('No changes were made.');
            }
        } catch (error) {
            toast.error(error.message || 'Failed to update email.');
        }
    };

    return (
        <form className="d-flex flex-column g-20" onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.row}>
                <input
                    className={classNames('field', { 'field--error': errors.email })}
                    type="email"
                    placeholder="Neue Email Adresse"
                    defaultValue={email}
                    {...register('email', { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/ })}
                />
            </div>
            <div className={styles.footer}>
                <button className="btn" type="submit">Email Aktualisieren</button>
                <button className="btn btn--outlined" type="reset" onClick={() => reset({ email })}>Cancel</button>
            </div>
        </form>
    );
};

UpdateTeamForm.propTypes = {
    teamID: PropTypes.string.isRequired,
};

export default UpdateTeamForm;
